<template>
  <div class="game-result">
    <div class="game-result-select">
      <div
        v-for="n in 10"
        :key="n"
        class="result"
        @click="onSelectResult(n - 1)"
      >
        <div class="check-mark" v-if="result && result == n - 1"></div>
        <p>{{ n - 1 }}</p>
      </div>
    </div>
    <div class="result-selected">
      {{ result }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    result: { type: String },
  },

  methods: {
    onSelectResult(n) {
      const result = String(n) == this.result ? "" : n;
      this.$emit("selected", result);
    },
  },
};
</script>
<style lang="scss" scoped>
.game-result {
  display: flex;
  align-items: center;

  .result-selected {
    font-weight: 700;
    font-size: 34px;
    margin: 0 auto;
  }
}
.game-result-select {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 280px;

  .result {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    line-height: 45px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    border-radius: 50%;

    cursor: pointer;
    position: relative;

    &:nth-child(even) {
      background: #6fc4b6;
    }

    &:nth-child(odd) {
      background: #f52828;
    }

    &:nth-child(1) {
      background: linear-gradient(
        rgb(245, 40, 40),
        rgb(234, 58, 240)
      ) !important;
    }

    &:nth-child(6) {
      background: linear-gradient(rgb(111, 196, 182), rgb(234, 58, 240));
    }
    p {
      margin-bottom: 0px;
    }
  }
}

.check-mark {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;

  display: inline-block;
  transform: rotate(45deg);
  height: 24px;
  width: 12px;
  border-bottom: 7px solid #78b13f;
  border-right: 7px solid #78b13f;
}
</style>